// packages / index.js
import './css/common.css'
import './css/modular.css'
// import ynApi from './utils/axios'
// import ViewUI from 'view-design'
// import 'view-design/dist/styles/iview.css'
// 导入单个组件
import ynHeader from './header/index'
import ynMenu from './menus/index'
import ynUplad from  './upload/index'
import ynTeacher from './teacher/index'
import ynGrade from './grade/index'
import ynEditor from './editor/index'
import ynClass from './class/index'
import select2v from './select2v/index'
import ynAddress from './address/index'

// 以数组的结构保存组件，便于遍历
const components = [
    ynHeader,
    ynMenu,
    ynUplad,
    ynTeacher,
    ynGrade,
    ynEditor,
    ynClass,
    select2v,
    ynAddress
]

// 定义 install 方法
const install = function (Vue) {
    if (install.installed) return
    install.installed = true
    // 遍历并注册全局组件
    components.map(component => {
        Vue.component(component.name, component)
    })
    // Object.defineProperties(Vue.prototype, {
    //     // 注意哦，此处挂载在 Vue 原型的 $axios 对象上
    //     $axios: {
    //         get() {
    //             return ynApi
    //         }
    //     }
    // })
}

if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue)
}

export default {
    // 导出的对象必须具备一个 install 方法
    install,
    // 组件列表
    components
}